export default function TwoImages({ imgSrc1, imgSrc2, image1Style, image2Style }) {
  return (
    <div
      className="s-about-img p-relative  wow fadeInLeft animated"
      data-animation="fadeInLeft"
      data-delay=".4s"
    >
      <img src={imgSrc1} alt="img" style={image1Style || { width: "90%" }} />
      <div
        className="about-icon"
        style={image2Style || {
          position: "absolute",
          bottom: "0px",
          right: "0px",
          width: "55%",
          height: "auto",
          borderLeft: "10px solid white",
          borderTop: "10px solid white",
        }}
      >
        <img src={imgSrc2} alt="img" />
      </div>
    </div>
  );
}
